<template>
  <div class="header">
    <nav class="uk-navbar-container uk-margin" uk-navbar>
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo uk-margin-left" href="https://www.checkmy-house.fr">
          <img width="70" height="70" src="../assets/logo-white.png" />
        </a>
      </div>
      <div class="uk-navbar-right" v-show="isConnected">
        <ul class="uk-navbar-nav">
          <li v-on:click="hasCompletedWebOnboarding() ? '' : displayErrorMessage()">
            <router-link to="/home">
              <a href="#" class="uk-text-bold">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: user"></span>
                Mon espace
              </a>
            </router-link>
          </li>
          <li>
            <router-link to="/settings">
              <a href="#" class="uk-text-bold">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: cog"></span>
                Paramètres
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import firebase from "firebase";
import UIkit from "uikit";

export default {
  name: "Header",
  data() {
    return {
      isConnected: false,
      currentUser: {}
    };
  },
  mounted() {
    const self = this;
    self.isConnected = localStorage.currentUser != null;
  },

  methods: {
    displayErrorMessage: function() {
      UIkit.notification(
        "<span uk-icon='icon: warning'></span> " +
          "Des informations sont manquantes pour accéder à votre espace. Avez-vous pensé à sauvegarder vos modifications ?",
        { pos: "bottom-center", status: "danger" }
      );
    },

    hasCompletedWebOnboarding: function() {
      if (localStorage.getItem("currentUser")) {
        try {
          this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        } catch (e) {
          localStorage.removeItem("currentUser");
        }
      }
      return this.currentUser.hasCompletedWebOnboarding
    }
  }
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
  text-decoration: none;
}

a:hover {
  background-color: #dcc390;
}

.uk-navbar-container {
  background-color: #dcc397;
}
</style>
